import { Space, Upload } from 'antd';
import styled from 'styled-components';
import { SecondaryButton } from '@lib/common';
import { useState } from 'react';
import { ImportedFilePreview } from '../imported-file-preview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var UploadContent = styled(Space).withConfig({
  displayName: "import-file-areacomponent__UploadContent",
  componentId: "sc-1efce2s-0"
})(["width:100%;text-align:center;"]);
var Guide = styled.div.withConfig({
  displayName: "import-file-areacomponent__Guide",
  componentId: "sc-1efce2s-1"
})(["text-align:center;"]);
var StyledText = styled.div.withConfig({
  displayName: "import-file-areacomponent__StyledText",
  componentId: "sc-1efce2s-2"
})(["font-weight:400;font-size:16px;line-height:24px;"]);
var SubText = styled.div.withConfig({
  displayName: "import-file-areacomponent__SubText",
  componentId: "sc-1efce2s-3"
})(["font-weight:400;font-size:14px;line-height:20px;"]);
var StyledUpload = styled(Upload).withConfig({
  displayName: "import-file-areacomponent__StyledUpload",
  componentId: "sc-1efce2s-4"
})(["background:#f5f5f5;display:flex;flex-direction:column;align-items:center;justify-content:center;height:250px;border:1px dashed #d9d9d9;border-radius:2px;&:hover{cursor:pointer;}.ant-upload-select{width:100%;}"]);
export var ImportFileArea = function ImportFileArea(props) {
  var importAreaLabel = props.importAreaLabel,
      onImportFileChange = props.onImportFileChange,
      filePreviewLabel = props.filePreviewLabel;

  var _useState = useState([]),
      files = _useState[0],
      setFiles = _useState[1];

  var onBeforeUpload = function onBeforeUpload(file) {
    setFiles([file]);
    onImportFileChange(file);
  };

  var onDeleteFile = function onDeleteFile() {
    setFiles([]);
    onImportFileChange(null);
  };

  var renderImportField = function renderImportField() {
    var content = /*#__PURE__*/_jsxs(UploadContent, {
      direction: "vertical",
      size: "middle",
      children: [/*#__PURE__*/_jsxs(Guide, {
        children: [/*#__PURE__*/_jsx(StyledText, {
          children: importAreaLabel.dragToUpload
        }), /*#__PURE__*/_jsx(SubText, {
          children: importAreaLabel.or
        })]
      }), /*#__PURE__*/_jsx(SecondaryButton, {
        children: importAreaLabel.findFileFromDevice
      })]
    });

    return /*#__PURE__*/_jsx(StyledUpload, {
      maxCount: 1,
      showUploadList: false,
      name: "file",
      multiple: false,
      accept: ".docx",
      beforeUpload: function beforeUpload(file) {
        return onBeforeUpload(file);
      },
      children: content
    });
  };

  var renderContent = function renderContent() {
    if ((files === null || files === void 0 ? void 0 : files.length) > 0) {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: files.map(function (file) {
          return /*#__PURE__*/_jsx(ImportedFilePreview, {
            size: file.size,
            name: file.name,
            onDelete: onDeleteFile,
            label: filePreviewLabel
          }, file.uid);
        })
      });
    }

    return renderImportField();
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderContent()
  });
};